export default "__VITE_ASSET__DwREX_xm__"